import GenericRequest, { METHOD_PUT } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import * as sha256 from 'sha256';

export default class AddUserRequest extends GenericRequest {

    // UserSave {
    //     id: number
    //     name: string
    //     last_name: string
    //     email: string
    //     image: string
    //     password: string
    //     role_id: number
    //     disabled: boolean
    //     contractor_id: number
    //     company_ids: number[]
    // }
    user;

    constructor(user) {
        super(METHOD_PUT, ApiEndpoints.USER_ADD);
        this.user = user;
    }

    overrideRequest() {
        let request = {};
        if ( this.user ) {
            request = { ...request, ...this.user };
            request.plain_password = request.password;
            request.password = sha256(request.password);
        }
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/users/ws/AddUserRequest.js